/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Push_DeniedInputs */

const en_settings_push_denied = /** @type {(inputs: Settings_Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications are blocked in your browser settings. Allow them for this site, then reload.`)
};

const he_settings_push_denied = /** @type {(inputs: Settings_Push_DeniedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ההתראות חסומות בהגדרות הדפדפן. אפשר אותן עבור אתר זה ואז טען מחדש.`)
};

/**
* | output |
* | --- |
* | "Notifications are blocked in your browser settings. Allow them for this site, then reload." |
*
* @param {Settings_Push_DeniedInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const settings_push_denied = /** @type {((inputs?: Settings_Push_DeniedInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Push_DeniedInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_push_denied(inputs)
	return he_settings_push_denied(inputs)
});